import { OralMedTemplate, MainLayout } from "@/design-system/Templates";
import Header from "@/design-system/Organisms/Header";
import { headerConfig } from "@/design-system/Organisms/Header/Header.config";
import { Footer } from "@/design-system/Organisms";
import { useScrollToTopOnMount } from "@/hooks/useScrollToTopOnMount";

const OralMedPage = () => {
  useScrollToTopOnMount();
  return (
    <MainLayout
      header={<Header {...headerConfig} />}
      sidebar={null}
      className=""
      footer={<Footer />}
    >
      <OralMedTemplate />
    </MainLayout>
  );
};

export default OralMedPage;
